import BackButton from '../../components/common/BackButton'
import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { supabase } from '../../lib/supabaseClient';
import "./NotificationDetail.css";

export default function NotificationDetail(){
  const location = useLocation();
  const { id } = useParams(); // URL에 있는 /notification/:id 값을 가져옴
  const [data, setData] = useState(location.state?.notificationData || null);

  useEffect(() => {
    if (data) return;
    const fetchSupabaseData = async () => {
      const {data, error} = await supabase
            .from('notifications')
            .select('*')
            .eq('id', id);
      
            if(error){
              console.error(error);
            }
            else{
              setData(data);
            }
    };
    fetchSupabaseData();
  }, [id, data]);

  // 수파베이스의 날짜 데이터를 자바스크립트용으로 변환
  const date = new Date(data.created_at + 'Z');

  // 날짜 및 시간 한국기준으로 세팅
  const formattedDateTime = date.toLocaleString('ko-KR', {
    year: 'numeric',   // 2026년
    month: 'long',     // 5월 (long을 쓰면 '월' 글자가 붙는다)
    day: 'numeric',    // 19일
    hour: '2-digit',   // 오전 06시 (또는 6시)
    minute: '2-digit'  // 06분
  });


  return(
    <div>
      <BackButton/>
      <div className="detail-container">
        {data ? (
        <>
          <h1>{data.title}</h1>
          <div>
            <p className="date">{formattedDateTime}</p>
            <hr/>
          </div>
          <div className="content">
            {data.content !=="null" && data.content}
          </div>
          {data.url &&
          <button 
          onClick={() => window.open(data.url, '_blank', 'noopener,noreferrer')}
          className="shortcut-button">
            원문 바로가기
          </button>
          }
        </>
        ) : (
          <p>데이터를 불러오는 중입니다...</p>
        )}
      </div>
    </div>
  );
}